import type { ChangeEvent } from "react";
import { styled } from "styled-components";

import { TextArea } from "common/components";
import { ClearInput } from "common/components/form/ClearInput";
import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { setCustomMapFields } from "domains/createMapDetail/actions";
import {
  getCurrentCustomMapDescription,
  getCurrentCustomMapName,
  getMapIsPending,
} from "domains/createMapDetail/selectors";

const StyledContainer = styled.div`
  margin-bottom: 10px;
`;

export const MapInfoInputs = () => {
  const dispatch = useDispatch();
  const translate = useTranslate();
  const name = useSelector(getCurrentCustomMapName);
  const description = useSelector(getCurrentCustomMapDescription);
  const isPending = useSelector(getMapIsPending);

  const onNameChange = (event: ChangeEvent<HTMLInputElement>) =>
    dispatch(setCustomMapFields({ name: event.target.value }));

  const onNameClear = () => dispatch(setCustomMapFields({ name: "" }));

  const onDescriptionChange = (description: string) => dispatch(setCustomMapFields({ description }));

  return (
    <>
      <StyledContainer>
        <ClearInput
          dataTestId="custom-map-info-title-input"
          isPending={isPending}
          label={translate("app.create.create_map.add_title")}
          name="title"
          onChange={onNameChange}
          onClearHandle={onNameClear}
          value={name}
        />
      </StyledContainer>
      <TextArea
        dataTestId="custom-map-info-description-input"
        isPending={isPending}
        name="description"
        onValueChange={onDescriptionChange}
        placeholder={translate("app.create.create_map.add_description")}
        value={description}
      />
    </>
  );
};
